<template>
  <div>

    <el-popover
      :placement="placement"
      :title="title"
      :width="width"
      :trigger="trigger"
      :content="content"
      popper-class="popover-drawing"
      :disabled="subData.length == 0"
    >
      <component
        v-if="config"
        :is="config.componentType"
        v-bind="config"
        :props="config.props"
      ></component>
      <div
        v-else
        class="drawing"
      >
        <div class="header">
          <span>任务名称</span>
          <span>任务进度</span>
        </div>
        <div class="main">

          <div
            class="main-item"
            v-for="item in subData"
            :key="item.id"
          >
            <span>{{item.name}}</span>
            <span :class="statusStyle(item.statusName)">{{item.statusName}}</span>
          </div>
        </div>
      </div>
      <span
        slot="reference"
        :style="[style]"
      >{{dataStyle}}</span>
    </el-popover>
  </div>
</template>

<script>
import formComponent from "@/components/iglobalwin/formComponents/index.js";
export default {
  props: ["tableData", "scope"],
  data() {
    return {};
  },
  computed: {
    style() {
      return this.tableData.style;
    },
    config() {
      return this.tableData.config;
    },
    placement() {
      return this.tableData.popover.placement || "bottom";
    },
    title() {
      return this.tableData.popover.title || "";
    },
    width() {
      return this.tableData.popover.width || 200;
    },
    trigger() {
      return this.tableData.popover.trigger || "hover";
    },
    content() {
      return this.tableData.popover.content || "1111";
    },
    dataStyle() {
      return (
        this.tableData.dataStyle && this.tableData.dataStyle(this.scope.row)
      );
    },
    subData() {
      return this.tableData.subData && this.tableData.subData(this.scope.row);
    }
  },
  methods: {
    statusStyle(val) {
      switch (val) {
        case "已完成":
          return "complete";
        case "进行中":
          return "underway";
        case "待开始":
          return "tostart";
      }
    }
  },
  components: {
    ...formComponent
  }
};
</script>

<style lang='scss'>
.popover-drawing {
  padding: 0;
}
.drawing {
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #333;
}
.drawing .header {
  width: 100%;
  height: 30px;
  background-color: #f2f4f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.drawing .main {
  width: 100%;
  background-color: #fff;
  padding: 5px 15px;
}
.drawing .main .main-item {
  padding: 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #54a8fe;
}

.complete {
  color: #67c23a;
}
.underway {
  color: #409eff;
}
.tostart {
  color: #909399;
}
</style>
